module.exports = __webpack_public_path__ + "static/logo-03fc04a27d970bfb12b40af436f7b19f.svg";